import React from 'react';
import { connect } from 'react-redux';
import { toEuros, estEnCoursDeChargement } from '../../App_Code/Utils';
import ConseilSyndical from '../../App_Data/ConseilSyndical';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Tableau from '../Tableau';

function ClasseSolde(solde) {
    return solde >= 0.0 ? 'text-right strong text-success' : 'text-right strong text-danger';
}

const LigneCoproprio = ({ Ind, Cpt, Couleur, SoldesPros_Visible, EstMembreCS }) => {
    const CS = ConseilSyndical(Ind.CS);
    return (
        <tr className={Couleur}>
            <td>
                <i className={`mr-3 ${CS.Icone}`} title={CS.TitreLong} />
            </td>
            <td>{Ind.Nom}</td>
            { (EstMembreCS && SoldesPros_Visible == 2) || SoldesPros_Visible==1
            ? <td className={ClasseSolde(Cpt.Solde)}>{toEuros(Cpt.Solde, true)}</td>
            : <td className={ClasseSolde(Cpt.Solde)}>&nbsp;</td>
            }
        </tr>
    );
};

const PageProprietaires = ({ Proprietaires, Ind, SoldesPros_Visible, EstMembreCS }) => {
    if (estEnCoursDeChargement(Proprietaires)) return <Chargement />;
    let solde = 0;

    const Entete = (
        <tr>
            <th>CS</th>
            <th>Nom et prénom</th>
            { (EstMembreCS && SoldesPros_Visible == 2) || SoldesPros_Visible==1 
            ? <th className="text-right">Solde</th>
            : <th className="text-right">&nbsp;</th>
            }
            </tr>
    );

    const Lignes = Proprietaires.map((pro, index) => {
        const Couleur = pro.Ind.Code === Ind.Code ? 'table-info' : '';
        solde += pro.Cpt.Solde;
        return <LigneCoproprio key={index} {...pro} SoldesPros_Visible={SoldesPros_Visible} EstMembreCS={EstMembreCS} Couleur={Couleur} />;
    });

    const Pied = (
        <tr className="table-primary">
            <th colSpan="2">Total</th>
            { (EstMembreCS && SoldesPros_Visible == 2) || SoldesPros_Visible==1 
            ? <th className={ClasseSolde(solde)}>{toEuros(solde, true)} €</th>
            : <th className={ClasseSolde(solde)}>&nbsp;</th>
            }
            
        </tr>
    );

    return (
        <div className="container col-xl-6">
            { (EstMembreCS && SoldesPros_Visible == 2) || SoldesPros_Visible==1
            ?
            <div className="alert alert-info">
                <strong>Soldes</strong> tenant compte d&apos;éventuels mouvements futurs programmés
            </div>
            :
            <div className="alert alert-info">&nbsp;</div>
            }
            <Tableau Entete={Entete} Lignes={Lignes} Pied={Pied} /> 
        </div>
    );
};
PageProprietaires.displayName = 'PageProprietaires';
PageProprietaires.requiredProps = [
    'Proprietaires', // Liste des propriétaires
    'Ind', // Information sur le propriétaire
];

function mapStateToProps({
    CopStore: { Proprietaires },
    ProStore: {
        Pro: { Ind },
    },
    SynStore: {
        Syn: {
            SoldesPros_Visible
        },
    },
    AdhStore: { EstMembreCS },

}) {
    return { Proprietaires, Ind, SoldesPros_Visible, EstMembreCS };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(PageProprietaires));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageProprietaires.js